import { FormArray, FormGroup } from '@angular/forms';
import { TranslateService } from '@ngx-translate/core';
import { ItmComboBoxItem } from 'src/app/shared/form-control/itm-combobox/itm-combobox.component';

export function containsInArray(firstArray: [], secondArray: []) {
	for (let i in firstArray) {
		if (secondArray.indexOf(firstArray[i]) === -1)
			return false;
		else
			return true;
	}
}

export function clearFormArray(formArray: FormArray) {
	formArray.controls = [];
	formArray.setValue([]);
}

export function clearFormGroup(fg: FormGroup, excludeKey: string = null) {
	const keys = Object.keys(fg.controls);
	keys.forEach(key => {
		if (!excludeKey || key != excludeKey) {
			if (fg.get(key) instanceof FormGroup)
				clearFormGroup(<FormGroup>fg.get(key), excludeKey);
			else if (fg.get(key) instanceof FormArray)
				clearFormArray(<FormArray>fg.get(key));
			else
				fg.get(key).reset();
		}
	});
}

export function getValidatorsFromControl(control) {
	return control && control.validator ? control.validator.call(control, "") || {} : {}
}

export function moveToTop() {
	console.log("moveToTop");
	let scrollToTop = window.setInterval(() => {
		let pos = window.pageYOffset;
		if (pos > 0) {
			window.scrollTo(0, pos - 20); // how far to scroll on each step
		} else {
			window.clearInterval(scrollToTop);
		}
	}, 16);
}

export function formatHourServerDate(date) {
	const splitted = (date || "").split(" ")[1] || "";
	return splitted.substring(0, splitted.lastIndexOf(":"));
}

export function getAllTipiTelefono(ts: TranslateService): Array<ItmComboBoxItem> {
	return [
		{ "value": "TF1", "descr": ts.instant("common.telefono_fisso1") },
		{ "value": "TF2", "descr": ts.instant("common.telefono_fisso2") },
		{ "value": "TM1", "descr": ts.instant("common.telefono_mobile1") },
		{ "value": "TM2", "descr": ts.instant("common.telefono_mobile2") },
		{ "value": "FAX", "descr": ts.instant("common.fax") }
	];
}